module.exports = __webpack_public_path__ + "static/elephant8-fd0d9eebf52b95d3d59506e2b163542d.jpeg";